export type IconId =
    | 'visCombined'
    | 'visDonut'
    | 'visFlatTable'
    | 'visGeolayers'
    | 'visArea100p'
    | 'visArea'
    | 'visBar100p'
    | 'visBar'
    | 'visColumn100p'
    | 'visColumn'
    | 'visLines'
    | 'visScatter'
    | 'visMetric'
    | 'visPie'
    | 'visPivot'
    | 'visTreemap'
    | 'collectionColored'
    | 'collectionColoredDark'
    | 'collectionColoredBig'
    | 'collectionColoredBigDark';
